// =========================================================================================@@
// Last Updated Date: Jan 22, 2022
// Last Updated By: Steven
// Status Level: 3
// ===========================================================================================

import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useInitiative } from 'src/core/graphql/hooks'
import GNS3ResourceView from 'src/sites/custom/gns3/Resource/View'
import Collection from 'src/sites/kits/Object/apps/Collection'
import CustomPage from 'src/sites/kits/Object/apps/CustomPage'
import DynamicListPage from 'src/sites/kits/Object/apps/DynamicListPage' // eslint-disable-line import/no-cycle
import DynamicViewPage from 'src/sites/kits/Object/apps/DynamicViewPage'
import { LayoutContainer, LayoutContainerInner } from 'src/sites/kits/UI'

const pageComponents = {
   custom: CustomPage,
   dynamic: DynamicListPage,
   media: CustomPage
}

const ObjectView = () => {
   const { initiativeSlug } = useParams()
   const { initiative, networkStatus } = useInitiative({ slug: initiativeSlug })
   const initialLoading = networkStatus <= 2

   // Note: This is currently only for GNS3
   const isUrlOrFilesResource = initiative?.class === 'resource' &&
      ['url', 'files'].includes(initiative?.resourceFormat)

   // TODO: Temp Fix - not sure why this is necessary
   // Right now, when navigating between pages, the scroll position
   // is always maintained. This is very confusing for users
   // especially on mobile - SY
   useEffect(() => {
      setTimeout(() => window.scrollTo({ top: 0 }), 0)
   }, [initiative?.id])

   if (initialLoading) {
      return null
   }

   if (isUrlOrFilesResource) {
      return <GNS3ResourceView />
   }

   if (initiative.class === 'medium') {
      // NOTE: use later ['grid', 'sidebar'].includes(initiative.protoFormat) &&
      return <Collection />
   }

   if (initiative.protoFormat === 'custom' || initiative.class === 'page') {
      const Page = pageComponents[initiative.pageFormat] || CustomPage
      return <Page />
   }

   if (initiative.protoFormat === 'custom') {
      return <CustomPage />
   }

   return (
      <LayoutContainer backgroundColor="#fff" maxWidth="750px[c] 1300px[e-f]">
         <LayoutContainerInner>
            <DynamicViewPage />
         </LayoutContainerInner>
      </LayoutContainer>
   )
}

export default ObjectView
